<template>
  <!--用户登录记录页面模版-->
  <div class="main">
    <a-card>
      <a-form ref="form" layout="inline">
        <a-row>

          <a-col :span="6">
            <a-form-item label="手机号码:">
              <a-input placeholder="请输入手机号码" style="width: 280px" allow-clear v-model="query.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 30px" @click="resetList">重置</a-button>
          </a-col>
        </a-row> 
        <!--表单-->
        <a-table size="middle" rowKey="id" :data-source="dataList" :dataListLoading="dataListLoading"
          :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :columns="columns" bordered
          :pagination="pagination" @change="pageChange">
          <span slot="basemapSelection" slot-scope="text, record">
            <a-tag color="green" v-if="text == 1" class="goodu">高德地图</a-tag>
            <a-tag color="cyan" v-if="text == 2" class="goodu">必应地图</a-tag>
            <a-tag color="red" v-if="text == 3" class="goodu">天地图</a-tag>
            <a-tag color="yellow" v-if="text == 4" class="goodu">星地图</a-tag>
          </span>
          <span slot="avatarAddress" slot-scope="text, record">
            <img :src="record.avatarAddress" width="50" height="50" alt="加载失败" />
          </span>
          <span slot="ifOpen" slot-scope="text,record">
            <a-switch :checked="(record.ifOpen == 0) ? true : false" @change="onRevealChangeUpdate(record)" />
          </span>
          <span slot="numberOfLogins" slot-scope="text, record">
            <a class="a-text" @click="LoginTimesDialog(record.phone)">{{ record.numberOfLogins }}</a>
          </span>
        </a-table>
      </a-form>
    </a-card>
    <!-- 登入次数弹窗 -->
    <a-modal title="登录次数详情" v-model="timesDialogVisible" width="50%" @ok="handleOk">
      <div class="table-scroll">
        <table class="gray-border-table">
          <tr>
            <td>手机号码</td>
            <td>登录状态</td>
            <td>创建时间</td>
          </tr>
          <tr v-for="(item, index) in goodslist" :key="item.id">
            <td>{{ item.phone }}</td>
            <td v-if="item.loginStatus == 1">
              <a-tag color="rgb(50, 205, 50)">成功</a-tag>
            </td>
            <td v-else> <a-tag color="#f12b35">失败</a-tag></td>
            <td>{{ item.createTime }}</td>
          </tr>
        </table>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '用户名称',
    dataIndex: 'userName',
    align: 'center',
  },
  {
    title: '手机号码',
    dataIndex: 'phone',
    align: 'center',
    width: '15%'
  },
  {
    title: '登录次数',
    dataIndex: 'numberOfLogins',
    align: 'center',
    scopedSlots: { customRender: 'numberOfLogins' }
  },
  {
    title: '底图选择',
    dataIndex: 'basemapSelection',
    align: 'center',
    scopedSlots: { customRender: 'basemapSelection' }
  },
  {
    title: '头像',
    dataIndex: 'avatarAddress',
    align: 'center',
    scopedSlots: { customRender: 'avatarAddress' }

  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    align: 'center',
  },
]
export default {
  name: 'UserConfiguration',
  data () {
    return {
      // 登入次数弹窗显示隐藏弹窗
      timesDialogVisible: false,
      addDialogVisible: false,
      isEditMode: false,
      orderColumn: '', // 排序列
      orderType: 'asc', // 正序为asc。倒序为desc
      // 查询参数
      query: {
        basemapSelection: '',
        phone: ''
      },
      needPage: true, // 是否需要分页
      dataListLoading: false, // 加载中
      selectedRows: [], // 选中的所有数据
      isadd: false,
      //输入框绑定
      phone: '',
      // 表格数据
      dataList: [],
      // 弹窗表格数据
      goodslist: [],
      // 分页数据
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      columns,
      labelCol: { span: 5 },
      wrapperCol: { span: 12 }
    }
  },
  computed: {

  },
  created () {
    this.resetList()
    this.queryList()
  },
  mounted () {
    this.queryList()
  },
  methods: {
    //查询数据
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http.get('/gis-manager/user/login/page', { params }).then(({ data }) => {
        this.dataListLoading = false
        if (this.needPage) {
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
          if (data.total > 0) {
            this.isadd = false
          } else {
            this.isadd = true
          }
        } else {
          this.dataList = data.list || []
        }
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 重置
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    // 选中的所有数据
    onSelectChange (selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    // 登入次数弹窗显示隐藏弹窗
    LoginTimesDialog (phone) {
      if (!phone) {
        return
      }

      this.$http.get('/gis-manager/user/login/get/' + phone).then(({ data }) => {
        this.goodslist = data
      }).catch(() => {
        this.dataListLoading = false
      })
      this.timesDialogVisible = true
      this.dataListLoading = true
    },
    // 分页查询
    pageChange (pagination, filters, sorter) { 
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pageQueryList()
    },
    pageQueryList () { 
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get('/gis-manager/user/login/page', {
          params
        })
        .then(({
          data
        }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.dataList = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.dataList = data.list || []
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleOk () {
      this.timesDialogVisible = false
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  min-height: 100%; 
}

.span,
a:hover {
  color: #42d309;
}

/deep/.ant-table-body {
  margin-top: 15px;
}

.fenye-top {
  margin-top: 15px;
}

/deep/.table-striped {
  background-color: #fafafa;
}

.goodu {
  font-size: 15px;
}

.text-width {
  width: 500px;
  font-size: 14px;
  background-color: bisque;
}

.kalaa {
  background-color: antiquewhite;
}

.gray-border-table {
  width: 500px;
  height: 40px;
  font-size: 15px;
  text-align: center;
  border-collapse: collapse;
  /* 使表格的边框线看起来是单一的线条 */
  width: 100%;
  /* 表格宽度 */
}

.gray-border-table th,
.gray-border-table td {
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid #aca9a9;
  /* 灰色边框线 #808080*/
  padding: 8px;
  /* 单元格内边距 */
  // text-align: left; /* 文本对齐方式 */
}

.table-scroll {
  height: 400px;
  /* 设置表格容器的高度 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
}
</style>